import React from 'react';
import { l10n } from '../with-app-root/i18n/i18nUtil';

interface Props {
  healthy: boolean;
  status: string;
}

const LicenseHealthStatus: React.SFC<Props> = (prop: Props) => {
  const { healthy, status } = prop;
  let shape;
  let className;
  let title;
  if (status !== 'EXPIRED') {
    shape = healthy ? 'success-standard' : 'warning-standard';
    className = healthy ? 'is-success' : 'is-warning';
    title = healthy
      ? l10n('lcops.environments.health.healthy')
      : l10n('notHealthy');
  } else {
    shape = 'warning-standard';
    className = 'is-danger';
    title = l10n('expired');
  }

  return (
    <clr-icon shape={shape} title={title} class={`is-solid ${className}`} />
  );
};

export default LicenseHealthStatus;
